import React from 'react';

const FacebookOutlined = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.92 1.297A3.06 3.06 0 0 1 5.084.4h1.523c.29 0 .525.235.525.525v2.03c0 .29-.236.525-.526.525H5.103v.98h1.505a.525.525 0 0 1 .51.652l-.508 2.03a.525.525 0 0 1-.509.398h-.997v3.535c0 .29-.236.525-.526.525h-2.03a.525.525 0 0 1-.525-.525V7.54h-.997A.525.525 0 0 1 .5 7.015v-2.03c0-.29.235-.525.525-.525h.998v-.998c0-.812.322-1.59.896-2.165m2.165.153a2.01 2.01 0 0 0-2.013 2.012v1.523c0 .29-.235.525-.525.525H1.55v.98h.997c.29 0 .525.235.525.525v3.535h.98V7.015c0-.29.236-.525.526-.525H5.69l.245-.98H4.578a.525.525 0 0 1-.526-.525V3.462A1.033 1.033 0 0 1 5.086 2.43h.997v-.98z"
            fill="#F7F7F7"
        />
    </svg>
);
export default FacebookOutlined;
